import React from 'react'
import PlusIcon from '../../../../components/elements/icons/PlusIcon'
import Filters from '../../../../components/elements/Filters'
import EmptyState from '../../../../components/elements/EmptyState'

const Requests = () => {
    const filterOptions = [
      {
        name: 'date applied',
        linkType: 'option',
        link: ['is after', 'is before'],
        type: 'date',
        value: "",
        displayValue: ""
      }
    ]
  
    return (
      <>
        <div className='w-full'>
          <div className="w-full mx-auto flex items-center justify-between">
            <div className='w-8/12'>
                <h4 className='font-medium text-lg mb-3 text-gray-400'>Inventory Requests</h4>
                <div className='w-2/3'>
                    <p className='text-gray-500 my-3 text-sm'>
                      You can request items from the inventory by clicking on "Make a request". Your requested items will be delivered when an inventory manager approves your request.
                    </p>
                </div>
            </div>
            <div className='w-4/12 flex flex-row-reverse'>
                <button className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                    <PlusIcon className='w-5 h-5' /> Make a request
                </button>
            </div>
          </div>

          <div className='w-full flex items-center justify-between my-5 p-2 rounded-md border'>
            <div className='w-full'>
              <Filters filterOptions={filterOptions} />
            </div>
            <div className='w-4/12 flex flex-row-reverse gap-x-2'>
              {/* <button onClick={()=>{}} className={`text-gray-700 px-3 py-2 hover:bg-gray-100 transition duration-200 text-sm flex items-center justify-center gap-x-2 bg-gray-200 rounded border`}>
                <ArrowUpTrayIcon className={`w-5 h-5`} />
                Export Subjects List
              </button> */}
            
            </div>
          </div>

          {/* {staffSelector?.loadingStaff ? 
            <Loader />
            : */}
            <>
              {/* {staffSelector?.staffMembers?.staff?.length > 0 ? 
                <div className=''>
                  {view === 'grid' && 
                    <>
                      <div className='mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-8'>
                        {staffSelector?.staffMembers?.staff?.map((student, studentIndex)=>(
                          <div key={studentIndex}>
                            <StudentCard student={student} />
                          </div>
                        ))}
                      </div>
                      <Pagination 
                        pagination={{
                          perPage, 
                          page,
                          totalItems: staffSelector?.staffMembers?.total,
                        }} 
                        changePage={setPage} 
                        updatePerPage={setPerPage}
                      />
                    </>
                  }
                  {view === 'list' && <div className='w-full'>
                    <DataTable
                      tableHeaders={tableHeadersFields(cleanUpTableData(staffSelector.staffMembers.staff)[0]).headers} 
                      tableData={cleanUpTableData(staffSelector.staffMembers?.staff)} 
                      columnWidths={columnWidths}
                      columnDataStyles={columnDataStyles}
                      allFields={tableHeadersFields(cleanUpTableData(staffSelector.staffMembers?.staff)[0]).fields}
                      onSelectItems={()=>{}}
                      tableOptions={tableOptions}
                      pagination={{
                          perPage, 
                          page,
                          totalItems: staffSelector.staffMembers.total,
                      }}
                      onSelectSingle={()=>{}}
                      changePage={setPage}
                      updatePerPage={setPerPage}
                    />
                  </div>
                  }
                </div>
                :  */}
                <div className='mt-24 w-1/2 mx-auto'>
                  <EmptyState emptyStateText={`No inventory requests yet! You can create new request by clicking on "Make a request" above`} />
                </div>

              {/* } */}
            </>
          {/* } */}
        </div>
      </>
    )
}

export default Requests